import { render, staticRenderFns } from "./Search-user.vue?vue&type=template&id=b9fc40ae&scoped=true"
import script from "./Search-user.vue?vue&type=script&lang=js"
export * from "./Search-user.vue?vue&type=script&lang=js"
import style0 from "./Search-user.vue?vue&type=style&index=0&id=b9fc40ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fc40ae",
  null
  
)

export default component.exports